<div class="flex flex--center fill grow">
  <fcom-icon [name]="'transfer-loader'" class="spinner-round-arrow {{ classes }}"></fcom-icon>
</div>
